import * as React from 'react'

const SvgNumberStepsIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3890_88136)">
      <path
        d="M17.8431 10.2939C16.7877 10.2939 15.9076 11.056 15.7226 12.0587H12.1204C11.9354 11.056 11.0553 10.2939 9.99996 10.2939C8.94463 10.2939 8.06451 11.056 7.87949 12.0587H4.27733C4.09231 11.056 3.2122 10.2939 2.15686 10.2939C0.967569 10.2939 0 11.2615 0 12.4508C0 13.6401 0.967569 14.6077 2.15686 14.6077C3.06949 14.6077 3.85098 14.0376 4.16545 13.2351H7.99141C8.30588 14.0376 9.08737 14.6077 10 14.6077C10.9126 14.6077 11.6941 14.0376 12.0086 13.2351H15.8345C16.149 14.0376 16.9305 14.6077 17.8431 14.6077C19.0324 14.6077 20 13.6401 20 12.4508C20 11.2615 19.0324 10.2939 17.8431 10.2939ZM2.15678 13.4312C1.6162 13.4312 1.17639 12.9914 1.17639 12.4508C1.17639 11.9102 1.6162 11.4704 2.15678 11.4704C2.69737 11.4704 3.13718 11.9102 3.13718 12.4508C3.13718 12.9914 2.69737 13.4312 2.15678 13.4312ZM9.99992 13.4312C9.45933 13.4312 9.01953 12.9914 9.01953 12.4508C9.01953 11.9102 9.45933 11.4704 9.99992 11.4704C10.5405 11.4704 10.9803 11.9102 10.9803 12.4508C10.9803 12.9914 10.5405 13.4312 9.99992 13.4312ZM17.8431 13.4312C17.3025 13.4312 16.8627 12.9914 16.8627 12.4508C16.8627 11.9102 17.3025 11.4704 17.8431 11.4704C18.3836 11.4704 18.8235 11.9102 18.8235 12.4508C18.8235 12.9914 18.3836 13.4312 17.8431 13.4312Z"
        fill="white"
      />
      <path
        d="M4.1173 7.94123H2.94083V3.23535H0.587891V4.41182H1.76436V7.94123H0.587891V9.1177H4.1173V7.94123Z"
        fill="white"
      />
      <path
        d="M11.7648 7.94123H9.41182V7.29869L11.7648 5.92614V3.23535H8.23535V4.41182H10.5883V5.25045L8.23535 6.623V9.1177H11.7648V7.94123Z"
        fill="white"
      />
      <path
        d="M8.23535 15.5879H11.7648V16.7644H8.23535V15.5879Z"
        fill="white"
      />
      <path
        d="M19.4112 3.23535H15.8818V4.41182H18.2348V5.58829H16.4701V6.76476H18.2348V7.94123H15.8818V9.1177H19.4112V3.23535Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3890_88136">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgNumberStepsIcon
